import { GraphQLClient } from 'graphql-request';
import {
    consentGiveMutation,
} from './queries';

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initialize);
} else {
	initialize();
}

/*
* Script to handle the newsletter-signup.
*/
function initialize () {
    /*
    * Document has loaded.
    */
    console.log('newsletter.js loaded');

    const forms = document.querySelectorAll('.newsletter__form');

    forms.forEach((form) => {
        form.addEventListener('submit', submitForm);
    });
}

async function submitForm(e) {
    e.preventDefault();

    const formWrapper = e.target.closest('.newsletter__form-wrapper');
    const formSuccess = formWrapper.querySelector('.newsletter__form-success');
    const formSubmit = formWrapper.querySelector('.newsletter__form-submit');
    const formError = formWrapper.querySelector('.newsletter__form-error');
    formError.innerHTML = ''; // Reset error message

    let ids = [];
    if (e.target.dataset.type === 'business') {
        ids = [941];
    } else if (e.target.dataset.type === 'private') {
        ids = [12];
    } else {
        alert('No type defined');
        return;
    }

    const email = e.target.querySelector('input[name="email"]').value;
    if (!email) {
        formError.innerHTML = "Vennligst fyll inn e-postadresse.";
        return;
    }

    formSubmit.setAttribute('disabled', true);
    formSubmit.innerHTML = 'Sender...';

    const graphQLClient = new GraphQLClient(window.cornerstoneApiUrl);
    const data = await graphQLClient.request(consentGiveMutation, {
        email: email,
        consentIds: ids
    });

    if (data.room.people.consentsGive.userErrors && data.room.people.consentsGive.userErrors.length > 0) {
        formError.innerHTML = "Noe gikk galt. Vennligst prøv igjen senere.";
        formSubmit.innerHTML = "Registrer";
        formSubmit.removeAttribute('disabled');

        return;
    }

    e.target.classList.add('invisible');
    formSuccess.classList.add('active');
}